/**
 * Vanhojen ilmakuvien esittämiseen GFI-vastauksen muotoiluun tehty koodi.
 * Tason GFI-vastauksen oletetaan olevan Stringinä annettua GeoJSON:ia, josta haetaan
 * kaikista kohteista se, jolla on viimeisin vuosi.
 * 
 * - muotoilun käyttöönotto tasolle: layer.attributes.ORTHO_GFI_formatter = "latestPhotoYear"
 * - muotoilussa haettavan ominaisuustiedon nimi: layer.attributes.ORTHO_GFI_property = "[ominaisuustietokentän nimi]", määrittelemättömänä "kuvausvuosi"
 * - käyttäjälle näytettävä teksti: layer.attributes.ORTHO_GFI_label (voi olla string tai locale object, määrittelemättömänä "Vuosi")
 * 
 * Esim attributes kenttään: 
 * {
    "ORTHO_GFI_formatter": "latestPhotoYear",
    "ORTHO_GFI_property": "kuvausvuosi",
    "ORTHO_GFI_label": {
        "fi": "Vuosi",
        "en": "Year"
    }
   }
 * 
 * Käyttöönotto esim. applications alla index.js:ssä:
 * 
 *     import { OrtophotoTimeseriesGFIformatter } from '../../util/OrtophotoTimeseriesGFIformatter';
 *
 * Oskari.app.startApplication() callbackissä:
 * 
 *     sandbox.findRegisteredModuleInstance('MainMapModuleGetInfoPlugin').addLayerFormatter(new OrtophotoTimeseriesGFIformatter());
 */
export class OrtophotoTimeseriesGFIformatter {
  enabled(data = {}) {
    const layerAttributes = this.getLayerAttributes(data.layerId);
    return layerAttributes.ORTHO_GFI_formatter === "latestPhotoYear";
  }
  format(data = {}) {
    const layerAttributes = this.getLayerAttributes(data.layerId);
    try {
      const geojson = JSON.parse(data.content);
      const photoYearAttr = layerAttributes.ORTHO_GFI_property || 'kuvausvuosi';
      const label = Oskari.getLocalized(layerAttributes.ORTHO_GFI_label || 'Vuosi');
      const years = geojson.features.map(feature => parseInt(feature.properties[photoYearAttr], 10));
      const year = years.length ? Math.max(...years) : '-';
      return `<b>${label}:</b> ${year}`;
    } catch (err) {
      Oskari.log('OrtophotoTimeseriesGFIformatter').warn(`Couldn't format GFI data`, data);
    }
  }
  getLayerAttributes(id) {
    const layer = Oskari.getSandbox().getService('Oskari.mapframework.service.MapLayerService').findMapLayer(id);
    if (!layer) {
      return {};
    }
    return layer.getAttributes() || {};
  }
}
;